<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @add="add"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                @del="del"
                ref="SetBtn"
        ></buttonlist>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="ecnprojectuser"
                :header="tableHeader"
                :option="tableOption"
                @handleSelectionChange="handleSelectionChange"
                ref="singleTable"
                @lct="editInfo"
        ></wTable>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ecnprojectuser" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[497]')" queryData="ecnprojectuser" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        
        <el-dialog v-dialogDrag :visible.sync="isShowEdit" :title="$t('getapi[34]')" width="33%" :close-on-click-modal="false">
            
            <el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[6129]')}}</td>
					<td>
                        <el-input  type="text" v-model="dataDetail.strategy_no"
                                    readonly
                                    size="mini"
                                    class="mcolor"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectstrategy()"></i>
                        </el-input>
                    </td>
					<td>{{$t('getapi[6199]')}}</td>
					<td><el-input v-model="dataDetail.strategy_content" readonly type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[118]')}}</td>
					<td>
						<el-select filterable v-model="dataDetail.item_type_id" @change="changeitemtype" :placeholder="$t('getapi[118]')" size="mini">
                            <el-option v-for="item in allEngTypeArray" :key="item.Code"
                                        :label="item.Name" :value="item.Code">
                            </el-option>
                        </el-select>
					</td>
                    <td>{{$t('getapi[12777]')}}</td>
					<td>
						<el-select filterable :disabled="!usertype" v-model="dataDetail.user_type" @change="changeusertype" :placeholder="$t('getapi[12777]')" size="mini">
                            <el-option v-for="item in arruser_type" :key="item.value"
                                        :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
					</td>
                    
				</tr>
                <tr>
                    
					<td>{{$t('getapi[3139]')}}</td>
					<td>                         
                        <el-input  type="text" v-model="dataDetail.user_name"  
                                    readonly
                                    size="mini"
                                    class="mcolor" 

                        >
                            <i  class="el-icon-edit el-input__icon" v-if="!username" slot="suffix" @click="selectEmployee()"></i>
                        </el-input>
                        
                    </td>
					<td>{{$t('getapi[410]')}}</td>
					<td><el-input v-model="dataDetail.create_person" readonly type="text" size="mini" ></el-input></td>
                    </tr>
                <tr>
                    <td>{{$t('getapi[409]')}}</td>
					<td><el-input v-model="dataDetail.create_time" readonly type="text" size="mini" ></el-input></td>
				
					<td>{{$t('getapi[733]')}}</td>
					<td><el-input v-model="dataDetail.modify_person" readonly type="text" size="mini" ></el-input></td>
                    </tr>
                <tr>
                    <td>{{$t('getapi[734]')}}</td>
					<td><el-input v-model="dataDetail.modify_time" readonly type="text" size="mini" ></el-input></td>                     
				
                    <td>{{$t('getapi[143]')}}</td>
					<td>
                        <el-input v-model="dataDetail.remark" type="text" size="mini" ></el-input>
                    </td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isShowEdit = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" @click="save" :loading="loading"
                           :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>


        <!--人员-->
        <selector :isVisible="false" :isBatch=false  :isSplitPage=true
                  :postUrl="'/Eng/ECN/GetEcnQualityUsersPopuDataList'" @callback="getEmployee" ref="employee"></selector>

        <selector :isVisible="false" :isBatch=false  :isSplitPage=true
                  :postUrl="'/Eng/ECN/GetEcnStrategyPPopupList'" @callback="getstrategy" ref="strategy"></selector>

                  
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'ecnprojectuser',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('ecnprojectuser'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData:[],
                selectIDData: [],
                allEngTypeArray: [],
                usertype:true,
                username:false,
                btn: {
                    edit: false,
                },
                arruser_type: [
                    {
                        value: 1,
                        label: this.$t('getapi[12770]')//'项目负责人'
                    },
                    {
                        value: 2,
                        label: this.$t('getapi[12771]')//'项目经理'
                    },
                    {
                        value: 3,
                        label: this.$t('getapi[12772]')//'项目计划员'
                    },
                    {
                        value: 4,
                        label: this.$t('getapi[12773]')//'项目质量工程师'
                    },
                    {
                        value: 5,
                        label: this.$t('getapi[12774]')//'项目工装设计人'
                    },
                    {
                        value: 6,
                        label: this.$t('getapi[12775]')//'固定'
                    },
                    {
                        value: 7,
                        label: this.$t('getapi[12776]')//'按工程类别'
                    },
                    {
                        value: 8,
                        label: this.$t('getapi[13113]')//'物料计划员'
                    },
                    {
                        value: 9,
                        label: this.$t('getapi[13114]')//'项目助理'
                    }
                ],
                isShowEdit: false,
                dataDetail: {
                    exclusively_id: 0,
                    strategy_no: '',
                    strategy_content: '',
                    item_type_id: '',
                    item_type_name: '',
                    user_num: '',
                    user_name: '',
                    create_person: '',
                    create_time: '',
                    modify_person: '',
                    modify_time: '',
                    remark: '',
                    user_type:6

                },
                scrollTop:0,
            };
        },
        mounted: function() {
            let that = this;
            that.allEngTypeArray = Array.methods.getAllEngType();
            that.colsort();
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.authority();
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ecnprojectuser', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12767]"),this.$t("getapi[18]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.$limits.authority('plv2', 35, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 35, 1) == 2) {
                    if (that.$limits.authority('plv3', 35,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 35,1) == 1) {
                        that.btn.edit = true
                        //编辑级
                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                    }
                    if (that.$limits.authority('plv3', 35, 1) == 2) {
                        that.btn.edit = true
                        //删除级
                        if(that.selectData.length > 0 ){
                            that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,del');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                        }
                    }
                }
                //只读权
                that.btnauthority()
            },
            changeitemtype() {
                let that = this;
                if (that.dataDetail.item_type_id >0) {
                    that.dataDetail.user_type = 7;
                    that.usertype=false;
                }
                else{
                    that.usertype=true;
                }
                that.changeusertype();
            },            
            changeusertype() {
                let that = this;
                if(that.dataDetail.user_type>=1 && that.dataDetail.user_type<=5){
                    that.dataDetail.user_name=''
                    that.dataDetail.user_num=''
                    that.username=true;
                }
                else{
                    that.username=false;
                }
                
            },
            btnauthority(){
                let that = this
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('ecnprojectuser',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ecnprojectuser');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Eng/ECN/GetProjectUserView', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndexs)
                    });
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Eng/ECN/EcnProjectUserViewToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            handleSelectionChange(val){
                let that = this;
                that.selectIDData = '';
                that.selectData = []
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].exclusively_id + ',';
                    that.selectData.push(val[i])
                }
                that.authority()
            },
            del(){
                let that = this
                let ids = that.selectIDData.substring(0,that.selectIDData.length -1)
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            ids: ids
                        }
                        that.$http.urlpost('/Eng/ECN/DeleteEcnProjectUserByID', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            editInfo(row){
                let that = this
                that.isShowEdit = true
                that.dataDetail.exclusively_id= row.row.exclusively_id
                that.dataDetail.strategy_no= row.row.strategy_no
                that.dataDetail.strategy_content= row.row.strategy_content
                that.dataDetail.item_type_id= row.row.item_type_id
                that.dataDetail.item_type_name= row.row.item_type_name
                that.dataDetail.user_num= row.row.user_num
                that.dataDetail.user_name= row.row.user_name
                that.dataDetail.create_person= row.row.create_person
                that.dataDetail.create_time= row.row.create_time
                that.dataDetail.modify_person= row.row.modify_person
                that.dataDetail.modify_time= row.row.modify_time
                that.dataDetail.remark= row.row.remark
                that.dataDetail.user_type= row.row.user_type
            },
            // 新增
            add() {
                let that = this;
                that.isShowEdit = true;
                let datetime = Common.methods.getDatetime()
                that.dataDetail = {
                    exclusively_id: 0,
                    strategy_no: '',
                    strategy_content: '',
                    item_type_id: '',
                    item_type_name: '',
                    user_num: '',
                    user_name: '',
                    create_person: '',
                    create_time: '',
                    modify_person: '',
                    modify_time: '',
                    remark: '',
                    user_type:6,
                };
                that.changeitemtype();
            },
            save(){
                let that = this
                let parm ={
                    model:that.dataDetail,
                    LangType:that.$processdata.getLang()
                }
                that.$http.urlpost('/Eng/ECN/SaveEcnProjectUser', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isShowEdit = false
                        that.getView()
                    }
                });
            },
            selectEmployee(){
                let that = this;
                that.$refs.employee.clearInput(true);
            },
            getEmployee(data){
                let that = this
                console.log(data)
                that.dataDetail.user_num = data.code
                that.dataDetail.user_name = data.name
            },
            selectstrategy(){
                let that = this;
                that.$refs.strategy.clearInput(true);
            },
            getstrategy(data){
                let that = this
                console.log(data)
                that.dataDetail.strategy_no = data.strategy_no
                that.dataDetail.strategy_content = data.content
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
        margin-bottom: 5px!important;
    }
</style>
